import { useCallback } from "react";
import { useTranslation } from "react-i18next";

type XpEntryText = { feature: string; label: string; count: number; unit: string | null };
type AchievementText = { id: string; title: string; description: string };

export function useProgressText() {
    const { t } = useTranslation("common");
    const xpLabel = useCallback(
        (entry: XpEntryText) => t(`xp.features.${entry.feature}`, { defaultValue: entry.label }),
        [t]
    );
    const xpUnit = useCallback(
        (entry: XpEntryText) => (entry.unit ? t(`xp.units.${entry.feature}`, { count: entry.count, defaultValue: entry.unit }) : null),
        [t]
    );
    const achievementTitle = useCallback(
        (achievement: AchievementText) => t(`achievements.${achievement.id}.title`, { defaultValue: achievement.title }),
        [t]
    );
    const achievementDescription = useCallback(
        (achievement: AchievementText) => t(`achievements.${achievement.id}.description`, { defaultValue: achievement.description }),
        [t]
    );
    return { xpLabel, xpUnit, achievementTitle, achievementDescription };
}
